import formatFunctons from '@/components/mixins/format-functions'
import copyTextMixin from '@/components/mixins/copy-text-mixin'
import DateRangeFormModal from '@/components/modals/date-range-form-modal/date-range-form-modal.vue'
import CourierDetailModal from '@/components/modals/courier-detail-modal/courier-detail-modal.vue'
import PageDropdown from '@/components/page-dropdown/page-dropdown.vue'
import IcOpenList from '@/assets/svg/ic-open-list.svg?inline'
import IcPause from '@/assets/svg/ic-pause.svg?inline'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'
import IcBicycle from '@/assets/svg/ic_bicycle.svg?inline'
import IcCar from '@/assets/svg/ic-car.svg?inline'
import IcArrowUp from '@/assets/svg/ic-arrow-up.svg?inline'
import IcClose from '@/assets/svg/ic-close.svg?inline'
import IcCloseBtn from '@/assets/svg/ic-close-btn.svg?inline'
import IcCheckOn from '@/assets/svg/ic-check-on.svg?inline'
import IcDelete from '@/assets/svg/ic-delete.svg?inline'
import IcGainOn from '@/assets/svg/ic-gain-on.svg?inline'
import IcGainOff from '@/assets/svg/ic-gain-off.svg?inline'

export default {
  name: 'ShiftList',
  /**
   * formatFuncton:
   *  getFormatDate
   *  getShortId
   *  getCookedTime
   * 
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [formatFunctons, copyTextMixin],
  components: {
    DateRangeFormModal,
    CourierDetailModal,
    PageDropdown,
    IcOpenList,
    IcPause,
    IcEdit,
    IcBicycle,
    IcCar,
    IcArrowUp,
    IcClose,
    IcCloseBtn,
    IcCheckOn,
    IcDelete,
    IcGainOn,
    IcGainOff
  },
  props: {
    shiftType: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },

    /**
     * проброс на page-dropdown
     */
    isOpened: {
      type: Boolean,
      default: true
    },
    isEqualShares: {
      type: Boolean,
      default: false
    },
    isLastInList: {
      type: Boolean,
      default: false
    },
    countInColumn: {
      type: Number,
      default: 1
    }
    /**
     * конец проброс на page-dropdown
     */
  },
  data() {
    return {
      shiftToChange: null,

      editCourierId: null
    }
  },
  computed: {
    editModalTexts() {
      let fullName = ''
      if (this.shiftToChange) {
        const courierObj = this.getCourierObjShift(this.shiftToChange)
        fullName = `${courierObj.last_name} ${courierObj.first_name}`
      }
      switch (this.shiftType) {
        case 'rest_couriers':
          return {
            header: 'Создание смены',
            description: `Создать смену для курьера ${fullName ? `<div><b>${fullName}</b>?<div>` : '?'}`,
            startLabel: 'Начало смены',
            endLabel: 'Окончание смены',
            btnSubmit: 'Создать'
          }
        default: 
          return {
            header: 'Изменить время смены',
            description: `Вы уверены, что хотите изменить время смены для курьера ${fullName ? `<div><b>${fullName}</b>?<div>` : '?'}`,
            startLabel: 'Начало смены',
            endLabel: 'Окончание смены',
            btnSubmit: 'Сохранить'
          }
      }
    },
    waitActionCount() {
      return this.list.filter(shift => {
        return ['approve_open', 'approve_close'].indexOf(shift.available_action) !== -1
      }).length
    }
  },
  methods: {

    getCourierObjShift(shift) {
      if (this.shiftType === 'rest_couriers') {
        return shift
      } else {
        return shift.courier
      }
    },
    getFormatCourierName(shift) {
      const courierObj = this.getCourierObjShift(shift)
      if (courierObj.first_name && courierObj.last_name) {
        return `${courierObj.last_name} ${courierObj.first_name.charAt(0).toUpperCase()}.`
      }
      return ''
    },
    getRoutTaskText(routeTaskId, isShort = false) {
      return `м ${isShort ? this.getShortId(routeTaskId) : routeTaskId}`
    },
    selectRouteTask(event, routeTaskId) {
      if (this.isShiftPress) {
        this.onCopyText(event, this.getRoutTaskText(routeTaskId))
        return
      }
      this.$emit('get-route-task', routeTaskId)
    },
    openTimesChangeModal(shift) {
      this.shiftToChange = shift
      this.$nextTick(() => {
        this.$refs['date-range-form-modal'].show()
      })
    },
    onChangeDateRange(event) {
      if (this.shiftType !== 'rest_couriers') {
        this.$emit('set-action-shift', {
          shift_id: this.shiftToChange.shift_id,
          data: {
            action: 'modify_working_period',
            datetime_start: this.$moment(event.dateFrom).utc().format(),
            datetime_end: this.$moment(event.dateTo).utc().format()
          }
        })
      } else {
        this.$emit('create-new-shift', {
          courier_id: this.getCourierObjShift(this.shiftToChange).courier_id,
          datetime_start: this.$moment(event.dateFrom).utc().format(),
          datetime_end: this.$moment(event.dateTo).utc().format()
        })
      }
      this.shiftToChange = null
      this.$refs['date-range-form-modal'].hide()
    },

    async showCourierInfo(event, shift) {
      if (this.isShiftPress) {
        this.onCopyText(event, shift.shift_id)
        return
      }
      this.editCourierId = this.getCourierObjShift(shift).courier_id
      
      this.$nextTick(() => {
        this.$refs['courier-detail-modal'].show()
      })
    },
    onCourierShiftChange() {
      this.$emit('courier-shift-change', this.editCourierId)
    },
    getTimeArray(shift) {
      const result = []
      if (shift.time_from && shift.time_to) {
        result.push({
          type: 'currentShift',
          times: {
            start: shift.time_from,
            end: shift.time_to
          }
        })
      }
      if (shift.gain_info) {
        result.push({
          type: 'gain',
          attended: shift.gain_info.attended,
          times: {
            start: shift.gain_info.time_from,
            end: shift.gain_info.time_to
          }
        })
      }
      return result.sort((a, b) => {
        const aStart = this.$moment(a.times.start)
        const bStart = this.$moment(b.times.start)
        const diff = aStart.diff(bStart)
        if (diff < 0) {
          return -1
        }
        if (diff > 0) {
          return 1
        }
        return 0
      })
    }
    
  }
}